import React, { Suspense } from 'react';
import { AnalyticsKeys, TrackPageLoad } from '@atlassian/ptc-common';
import RecordTransition from '../components/RecordTransition';
import SearchPage from '../components/SearchPage/lazy';
const SearchPageRoute = () => {
  const url = new URL(window.location.href);
  const searchQuery = url.searchParams.get('q') || '';
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RecordTransition, {
    name: AnalyticsKeys.PEOPLE_VIEW
  }), /*#__PURE__*/React.createElement(TrackPageLoad, {
    name: AnalyticsKeys.PEOPLE_VIEW
  }), /*#__PURE__*/React.createElement(Suspense, {
    fallback: null
  }, /*#__PURE__*/React.createElement(SearchPage, {
    searchQuery: searchQuery
  })));
};
export default SearchPageRoute;